 
export class StorageKeyConstant
{
   
    public static USER_ID = "storageKey.userId";
    
    public static USERNAME = "username";
    public static CLIENT_DEVICE_ID = "tst";
}
